import { Eye, EyeClosed, RotateCcwIcon } from 'lucide-react';
import { useState } from 'react';

interface CardCommisionProps {
  income: number;
  onHistory?: () => void;
  clickTotal: number;
  unpaidCommission: number;
}

const CardCommision = ({
  income = 0,
  onHistory,
  clickTotal = 0,
  unpaidCommission = 0,
}: CardCommisionProps) => {
  const [showIncome, setShowIncome] = useState(false);
  const formatNumber = new Intl.NumberFormat('id-ID').format;
  const formattedIncome = formatNumber(income);
  return (
    <article className="gradient w-full p-3 flex flex-col gap-3">
      <h3 className="title2medium uppercase text-white">TOTAL KOMISI DIDAPAT </h3>
      <div className="text-white inline-flex gap-3 items-center ">
        <div className="flex-3">
          <p className="h5bold w-full">Rp {showIncome ? `${formattedIncome}` : '*********'}</p>
        </div>
        <button type="button" className="flex-auto" onClick={() => setShowIncome((prev) => !prev)}>
          {showIncome ? <Eye /> : <EyeClosed />}
        </button>
        <button
          onClick={onHistory}
          type="button"
          className="rounded-[12px] bg-[rgba(255,255,255,0.50)] p-3 flex flex-col ml-auto gap-2 justify-center items-center text-black"
        >
          <RotateCcwIcon />
          <p className="reg12">Riwayat</p>
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-[12px] text-white bg-text-blue-10 p-3 border-white/20 border ">
          <p className="reg12">Total Klik Link </p>
          <p className="title2bold">{clickTotal}</p>
        </div>
        <div className="rounded-[12px] text-white bg-text-blue-10 p-3 border-white/20 border ">
          <p className="reg12">Komisi Belum Dibayarkan</p>
          <p className="title2bold">Rp {formatNumber(unpaidCommission)}</p>
        </div>
      </div>
    </article>
  );
};

export default CardCommision;
